<ng-container *ngIf="designPositions">
  <div class="main-container">
    <div class="pd-options-container mb-4">
      <div class="row pd-options-top d-none d-lg-flex">
        <mdb-accordion [flush]="true" class="pd-options">
          <!-- Dynamically creating accordion items -->
          <ng-container *ngFor="let item of designPositions; trackBy: trackPositions">
            <mdb-accordion-item (click)="onPositionSelect(item.position)" [collapsed]="item.position != position"
              *ngIf="item.canCustomize">
              <ng-template mdbAccordionItemHeader>
                <span class="pd-options-position-label ps-4">
                  {{ item.position | titlecase }}
                  <ng-container *ngIf="item.canCustomize && item.canvas && item.canvas.length > 0">
                    ({{ item.canvas.length }})
                  </ng-container>
                </span>
              </ng-template>
              <ng-template mdbAccordionItemBody>
                <ng-container *ngIf="!item.canCustomize">
                  <div class="alert alert-light text-center">
                    <span class="pd-options-initial">This position is not available for customization.</span>
                  </div>
                </ng-container>
                <ng-container *ngIf="item.canCustomize && item.canvas?.length > 0;">
                  <div class="row" *ngFor="let image of item.canvas; trackBy: trackImages"> <!-- Use image here -->
                    <div class="card mb-3">
                      <div class="row g-0">
                        <div class="col-md-3">
                          <img loading="lazy" [src]="image.url" class="img-fluid pdo-img"
                            [alt]="'Art image of ' + image.name" />
                        </div>
                        <div class="col-md-5 d-flex align-items-center">
                          <div class="card-body p-0">
                            <div class="row">
                              <div class="col-12">
                                <span class="pdo-img-name"
                                  style="display: block; overflow: hidden; white-space: nowrap; text-overflow: ellipsis;">{{
                                  image.name }}</span>
                              </div>
                            </div>
                            <div class="row">
                              <div class="col-12">
                                <span class="pdo-img-name"
                                  style="display: block; overflow: hidden; white-space: nowrap;"><strong>Color
                                    Count:</strong> {{ image.colorCount }} </span>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div class="col-md-4 d-flex align-items-center justify-content-center">
                          <button *ngIf="image.editable" class="btn btn-primary pdo-btn-p"
                            (click)="lockImage(image)">Place Art</button>
                          <a *ngIf="!image.editable" style="color: #000;" (click)="editImage(image)" role="button">
                            <i class="fas fa-pen pe-2"></i>
                          </a>
                          <a *ngIf="!image.editable" style="color: #000;" (click)="deleteImage(image)" role="button">
                            <i class="far fa-trash-alt"></i>
                          </a>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="row">
                    <label mdbLabel class="form-label pd-options-position-label"
                      [for]="'positionNotes_' + i">Notes</label>
                    <textarea mdbInput class="form-control pd-options-notes" [id]="'positionNotes_' + i" rows="2"
                      placeholder="Optional" [(ngModel)]="item.notes" (change)="onNotesChange()"></textarea>
                  </div>
                </ng-container>

                <!-- If item.images is empty, display the message -->
                <ng-container *ngIf="item.canCustomize && (!item.canvas || item.canvas?.length == 0)">
                  <div class="alert alert-light">
                    <span class="pd-options-initial">Select art from your library to get started.</span>
                  </div>
                </ng-container>
              </ng-template>
            </mdb-accordion-item>
          </ng-container>
        </mdb-accordion>
      </div>
      <hr class="pd-library-hr">
      <div class="row ps-2 pe-2">
        <label mdbLabel class="form-label ps-1" for="textAreaExample">
          <div class="label-container">
            <span class="pd-options-position-label"> Size</span>
            <span class="option-sizes-header" *ngIf="productTotals > 0">Prices shown for {{ productTotals }}
              units</span>
            <span class="option-sizes-header" *ngIf="!productTotals">Prices shown for 150 units</span>
            <span class="option-sizes-header text-danger" *ngIf="productTotals < 0">Quantities can't be negative</span>
          </div>
        </label>
        <ng-container *ngFor="let item of productSizes; let i = index; trackBy: trackByFn">
          <div class="col-3 p-2 text-center">
            <p class="mb-0 pd-option-size-label">{{item.size}}</p>
            <p class="mb-0 pd-option-size-label pb-1">${{item.price | formatPrice}}</p>
            <input mdbInput type="number" min="0" id="typeText" class="form-control pd-option-size-input"
              style="font-size: 12px;" [(ngModel)]="sizeQtys[i]" (input)="updatePricing($event)"
              *ngIf="sizeQtys?.length > 0" />
          </div>
        </ng-container>
      </div>
    </div>
    <div class="d-flex align-items-center bg-white p-2">
      <div
      class="icon-circle border rounded-circle"
        >
        ?
      </div>
      <div>
        <p class="mb-0 fw-bold pd-order-sample-header">Want to order a blank sample?</p>
        <p class="mb-0 text-muted">Add your quantity to cart without any artwork and check out! (Limit of 5)</p>
      </div>
    </div>
    <div class="price-container fixed-bottom">
      <div class="container p-0">
        <div class="row mt-2">
          <div class="col-12">
            <button *ngIf="!editingProduct" class="btn btn-primary add-cart" type="button"
              (click)="openAddToCartModal()">
              Add to Cart
            </button>
            <button *ngIf="editingProduct" class="btn btn-primary add-cart" type="button"
              (click)="addDesignToCart(cartToBeEdited, true)">
              Update Design
            </button>
          </div>
        </div>
        <div class="row mt-4">
          <div class="col-12">
            <p class="pd-options-legal">All orders are reviewed by our team. Once placed we will send professional
              mockups and
              test
              prints for you to approve prior to starting production.</p>
          </div>
        </div>
      </div>
    </div>
    <!-- </div> -->
  </div>
</ng-container>